import { createApp } from 'vue';
import App from './App.vue';
import '@/core/assets/main.css';
import 'primeicons/primeicons.css';

import { setupPrimeVueTheme } from '@/theme';

import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import KeyFilter from 'primevue/keyfilter';

import pinia from './core/stores';
import loadRouter from './core/router';
import RegisterCoreComponent from '@/core/components';
import type { Emitter } from 'mitt';
import bus from '@/plugins/bus';
import { setupSentry } from '@/plugins/sentry';
import i18n from '@/plugins/i18n';
import { Tooltip } from 'primevue';

const initApp = async () => {
  const app = createApp(App);

  const router = await loadRouter();

  app.use(router);

  setupSentry(app, router);

  setupPrimeVueTheme(app);

  app.use(ToastService);
  app.use(ConfirmationService);
  app.use(DialogService);
  app.directive('tooltip', Tooltip);
  app.directive('keyfilter', KeyFilter);

  app.use(pinia);
  app.use(i18n);

  RegisterCoreComponent(app);

  app.provide<Emitter<TBusEvent>>('bus', bus);

  app.mount('#app');
};

initApp();
